import { HttpClient } from "../../http/HttpClient";
import { ApiResponse } from "../../api/types/ApiResponse";
import { ApiResponseHandler } from "../../http/services/handleApiResponse/handleApiResponse";
import ProductsAccountsRepository from "@/core/customers/repositories/ProductsAccountsRepository";
import saveProductsAccountsUrl from "../../api/productsAccountsEndpoints/productsAccountsEndpoints";
import { ProductsAccountsBackendResponse } from "@/core/customers/entities/ProductsAccounts";

export default class ProductsAccountsRepositoryBackend
  implements ProductsAccountsRepository {
  constructor(private readonly httpClient: HttpClient) { }

  async saveProductsAccounts(
    businessKey: string,
    body: object
  ): Promise<boolean> {
    const response = await this.httpClient.post<ApiResponse<unknown>, object>({
      url: saveProductsAccountsUrl(businessKey),
      body,
      withAuth: true,
    });
    const result = ApiResponseHandler.handleResponse(response);
    return !!result.success;
  }

  async getProductsAccounts(businessKey: string): Promise<ProductsAccountsBackendResponse> {
    const response = await this.httpClient.get<ApiResponse<ProductsAccountsBackendResponse>>({
      url: saveProductsAccountsUrl(businessKey),
      withAuth: true,
    });
    const result = ApiResponseHandler.handleResponse(response);

    if (result.success && result.data !== undefined) {
      if (result.data === null) {
        const initData: ProductsAccountsBackendResponse = {
          customerType: "PERSONNE_PHYSIQUE",
          product: {
            code: "",
            label: "",
            category: ""
          },
          professionCategory: {
            code: "",
            name: ""
          },
          businessKey: ""
        }
        return initData;
      }
      return result.data;
    }
    throw new Error(result.message);
  }
}
